import {drop, eq, filter, keyBy, last, take, first} from "lodash-es";
import {RoundStatus} from "modules/enums";
import type {TStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getRounds = (store: TStore) => store.rounds;

export const getActiveRound = createSelector([getRounds], (rounds) =>
	rounds.find((it) => it.status !== RoundStatus.COMPLETE)
);

export const getFirstRound = createSelector([getRounds], (rounds) => first(rounds));

export const getFutureRounds = createSelector([getRounds], (rounds) => {
	const futureRounds = rounds.filter((it) => it.status !== RoundStatus.COMPLETE);
	const FUTURE_ROUNDS_LIMIT = 5;
	return take(drop(futureRounds, 1), FUTURE_ROUNDS_LIMIT);
});

export const getScheduledRounds = createSelector([getRounds], (rounds) =>
	rounds.filter((it) => it.status !== RoundStatus.SCHEDULED)
);

export const getRoundsById = createSelector([getRounds], (rounds) => keyBy(rounds, "id"));

export const getYesterdayCompletedRound = createSelector([getRounds], (rounds) => {
	const completeRounds = filter(rounds, (round) => eq(RoundStatus.COMPLETE, round.status));

	if (completeRounds.length >= 2) {
		return last(completeRounds);
	}

	return null;
});
